import styled from "styled-components";


const RadioLabel = styled.label`
  /* Estilos para el label */
  
`;

const RadioInput = styled.input`
  /* Estilos para el input radio */
  color: red;
`;

type IProps = {
    hasCuil: boolean;
    setHasCuil: Function;
}


const CuilRadioInput = ({ hasCuil, setHasCuil }: IProps) => {

    const handleOptionChange = (event: any) => {
        const value = event.target.value === "Si";
        setHasCuil(value);
    };

    return (
        <div className="flex justify-start align-middle">
            <h6>¿Tiene CUIL?</h6>
            <div className="ml-10 flex">
                <RadioLabel className="mx-3">
                    <RadioInput
                        type="radio"
                        value="Si"
                        checked={hasCuil}
                        onChange={handleOptionChange}

                    />
                    <span className="pl-2">Si</span>
                </RadioLabel>

                <RadioLabel className="mx-3">
                    <RadioInput
                        type="radio"
                        value="No"
                        checked={!hasCuil}
                        onChange={handleOptionChange}

                    />
                    <span className="pl-2">No</span>
                </RadioLabel>

            </div>


        </div>
    );
};

export default CuilRadioInput;